import React, { useContext, useState } from 'react'
import { menu } from './menuObj'
import styles from "./menu.module.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { store } from '../../state/state'

export default function Menu() {
  const [menuOpened, setMenuOpened] = useState(false)
  let {selectedLang} = useContext(store)
  return (
    <div className={styles['menu']}>
        <div className={`${styles['menu-panel']} ${menuOpened ? styles['menu-opened'] : ''}`} inert={!menuOpened}>
          <div className={styles['menu-items']}>
            { menu.map((item, index) => <a href={item.link} onClick={() => setMenuOpened(false)} className={styles['item']} key={index}>{item[selectedLang]}</a> ) }
          </div>
        </div>
        <span className={`${menuOpened ? styles['opened'] : styles['closed']}`} onClick={() => setMenuOpened(!menuOpened)}>
          <FontAwesomeIcon icon={faBars}  />
        </span>
    </div>
  )
}
